import React, { useState, useEffect } from 'react';

const NumberInput = ({ ...rest }) => {
  const symbol = rest.symbol !== undefined ? rest.symbol : '円';
  const [value, setValue] = useState(
    rest.value !== undefined ? rest.value.toString() : ''
  );
  const [isFocus, setFocus] = useState(false);
  const handleFocus = () => setFocus(true);
  // const handleBlur = () => setFocus(false);
  const handleBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (rest.onBlur) {
      rest.onBlur(event);
    }
    setFocus(false);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (rest.onChange) {
      rest.onChange(event);
    }
    setValue((event.target as HTMLInputElement).value);
  };
  // 自動見積りの定番小項目、単価平均のポップアップを出すときに使用
  const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
    if (rest.onClick) {
      rest.onClick(event);
    }
  };
  const isBlank = value === '';
  const isValid = /^[-]?(\d+)[.]?(\d+)?$/.test(value);
  const displayValue = (() => {
    if (isFocus || !isValid) {
      return value;
    }
    if (isValid) {
      return (+value).toLocaleString() + symbol;
    }
    return '';
  })();
  const displayStyle = {
    textAlign: 'right' as 'right',
    paddingRight: 5,
    backgroundColor: isValid || isBlank ? '#FFF' : '#FFBEDA'
  };
  const placeholderStyle = {
    textAlign: 'left' as 'left'
  };
  useEffect(() => {
    if (rest.value && rest.dynamicCalculation) {
      setValue(rest.value.toString());
    } else {
      if (
        (rest.value === undefined || rest.value === '') &&
        rest.dynamicCalculation
      ) {
        setValue('');
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest.value]);
  return (
    <input
      {...rest}
      maxLength={rest.maxLength}
      type='text'
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={handleChange}
      onClick={handleClick}
      value={displayValue}
      style={
        value
          ? {
              ...displayStyle,
              ...rest.style
            }
          : {
              ...placeholderStyle,
              ...rest.style
            }
      }
    />
  );
};
export default NumberInput;
